export default __webpack_public_path__ + "static/media/cerner1.7cf3e004.png";